import { Injectable, Inject } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';

@Injectable()
export class LoginService {

  constructor(private http: Http,) {
    this.status = { isLoggedIn: false, token: "", username: ""};
  }

  private doLoginURL = environment.BASE_URL + environment.RESOURCES.LOGIN;

  private status: {
    isLoggedIn: boolean,
    token: string,
    username: string
  }

  private user = new Subject<string>();
  private loggedIn = new Subject<boolean>();

  private updateSubscriptions(user: string, loggedIn: boolean) {
    this.loggedIn.next(loggedIn);
    this.user.next(user);
  }

  private clearStatus() {
    this.status.isLoggedIn = false;
    this.status.token = "";
    this.status.username = "";
    this.updateSubscriptions("", false);
  }

  private setLogin(username: string, token: string) {
    this.status.isLoggedIn = true;
    this.status.token = token;
    this.status.username = username;
    this.updateSubscriptions(username, true);
  }

  public getUserObservable() {
    return this.user.asObservable();
  }

  public getLoggedInObservable() {
    return this.loggedIn.asObservable();
  }

  public getUsername(): string {
    return this.status.username;
  }

  public isLoggedIn(): boolean {
    return this.status.isLoggedIn;
  }
  
  public authenticate(user: string, passwd: string): Promise<boolean> {
    let success = false;

    const body = {
      'usr': user,
      'pwd': passwd
    };
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8');
    return this.http.post(this.doLoginURL, body, {
      headers: headers
    }).toPromise().then((response) => {
      console.log("login service: good credentials");
      // We are logged in
      this.setLogin(user, "");
      return true;
    }).catch(response => {
      this.clearStatus();
      console.log("login service: bad credentials");
      return false;
    })
  }

  public logOut() {
    console.log("login service: log out");
    this.clearStatus();
  }

}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/services/login/login.service.ts